import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { toFilter } from 'utils/widgetUtil'
import InsightViewOption from 'enums/InsightViewOption'
import MeasureType from 'enums/MeasureType'
import { TopicInfo } from 'schemas/TopicInfoSchema'
import { FilterTypeStrings } from 'enums/FilterType'
import AnalysisFilter from 'types/analysisFilter'
import { TopicComparisonWidgetType } from '../../types'

// eslint-disable-next-line import/prefer-default-export
export const convertToInsightContentSetting = (
  widgetSetting: TopicComparisonWidgetType,
  selection?: { insights?: Array<InsightData> }
) => {
  const insights = selection ? selection?.insights : null
  const insightContentSetting = {
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [] as FilterTypeStrings[],
    drillDownFilter: {} as AnalysisFilter,
    topicId: insights?.[0]?.topicId
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (widgetSetting.topicComparisonMeasures!.includes(MeasureType.MENTIONS)) {
    insightContentSetting.viewOption = InsightViewOption.MENTIONS
  }
  if (widgetSetting.topicComparisonMeasures!.includes(MeasureType.POSTS)) {
    insightContentSetting.viewOption = InsightViewOption.POSTS
  }

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = insights?.[0].topicName || ''
    insightContentSetting.selectedTopicInfo = widgetSetting.topicInfos?.filter(
      (topicInfo) => topicInfo.topicId === insights?.[0].topicId
    )?.[0] as TopicInfo

    insightContentSetting.selectionFilter = toFilter(widgetSetting)
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: TopicComparisonWidgetType,
  selection: { insights?: Array<InsightData> }
): TopicComparisonWidgetType => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    return {
      ...widgetSetting,
      selectedTopic: widgetSetting.topicInfos?.filter(
        (topicInfo) => topicInfo.topicId === selection.insights?.[0]?.topicId
      )?.[0] as TopicInfo
    }
  }
  return {} as TopicComparisonWidgetType
}
